// export const API_URL = 'https://tms-backend-ee36.onrender.com'
export const API_URL = 
process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:4000' : 
'https://api.oumchealth.org/tms'


export const HR_API_URL = 
process.env.NODE_ENV === 'development' ? 'http://localhost:49491' : 
'https://api.oumchealth.org/hrsuit'